export const generateSimulationTableId = (assetType: string): string => {
	return `iwp_hydqua_result_${assetType}`;
};
